import { IKnmObjectType } from 'APIPackage/CatalogsModule/interfaces/IKnmObjectType';

import { IKnmObjectTypeSelectOption } from '../interfaces/IKnmObjectTypeSelectOption';

export const createKnmObjectTypeSelectOption = (knmObjectType: IKnmObjectType): IKnmObjectTypeSelectOption => ({
  ...knmObjectType,
  label: knmObjectType.name || '',
  value: knmObjectType.code,
});
